import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState: any = {};

const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setCurrentTenant:(state,action) =>{
      return action.payload;
    },
    reset: () => initialState,
  },
});

export const { reset, setCurrentTenant } = tenantSlice.actions;

export const getTenant = (state: RootState) => state.tenant;

export default tenantSlice.reducer;
